export const CONTENT_TYPES = [
    {"id": 1, 'name': 'お知らせ'},
    {"id": 2,'name': 'ニュース'},
    {"id": 3,'name': 'イベント'},
    {"id": 4,'name': 'コラム'}
]

// Working age
export const WORKING_AGE = 18;

export const PERMISSIONS = {
    ACTION_MENU: "action_display_menu",
    ACTION_NEW: "action_new",
    ACTION_EDIT: "action_edit",
    ACTION_DELETE: "action_delete",

    JOB_MENU: "job_display_menu",
    JOB_NEW: "job_new",
    JOB_EDIT: "job_edit",
    JOB_DELETE: "job_delete",

    NEWS_MENU: "news_display_menu",
    NEWS_NEW: "news_new",
    NEWS_EDIT: "news_edit",
    NEWS_DELETE: "news_delete",
    NEWS_NOTI_SETTING: "news_noti_setting",

    USER_MENU: "user_display_menu",
    USER_NEW: "user_new",
    USER_EDIT: "user_edit",
    USER_DELETE: "user_delete",

    HISTORY_MENU: "history_display_menu",
    HISTORY_NEW: "history_new",
    HISTORY_EDIT: "history_edit",
    HISTORY_DELETE: "history_delete",
};

export const PERMISSION_MAPPING_URL = [
    {permission: "action_display_menu", url: "/company/action"},
    {permission: "job_display_menu", url: "/company/job"},
    {permission: "job_new", url: "/company/job/import"},
    {permission: "news_display_menu", url: "/company/content"},
    {permission: "news_noti_setting", url: "/company/notification-setting"},
    {permission: "user_display_menu", url: "/company/staff"},
    {permission: "history_display_menu", url: "/company/history"},
    {permission: "talent_register_import", url: "/company/talent/import"}
]


export const IMPORT_JOB = {
    MAX_FILE_SIZE: 1 * (1024 * 1024),
    FILE_SIZE_ON_LOADING: 0.1 * (1024 * 1024),
}

export const MESSAGE_TYPE = {
    COMPANY_DISCUSS: 'company_discuss',
    SCOUT: 'scout',
    TALENT_DISCUSS: 'talent_discuss',
    APPLY: 'apply',
}

export const TALENT_TEMP_STATUS = {
    NEW: 'new',
    REGISTERED: 'registered',
    APPROVING: 'approving',
    APPROVED: 'approved',
}

export const MAX_FILE_SIZE = {
    IMPORT_TALENT: 1 * 1024 * 1024,
    MESSAGE: 8,
    RESUME_FILE: 32 * 1024 * 1024,
}

export const MIN_YEAR_CUSTOM_DATE_PICKER = 1990;

export const ANNUAL_SALARY_UNIT = 10000;

export const RECRUITMENT_STATUS_OPTION_TYPE = "job_status";

export const RECRUITMENT_STATUS = {
    PRIVATE: 'private',
    RECRUITING: 'recruiting',
    CLOSED: 'closed',
}

export const NO_ANSWER_JOB_CHANGE_SITUATION = 'no_answer';

export const ACTION_TYPE = {
    SCOUT: 'action_scout',
    APPLY: 'action_apply'
};

export const USER_ROLE = {
    COMPANY: 'company',
    TALENT: 'talent',
    CONTROL: 'control',
};

// Default input max length
export const DEFAULT_INPUT_MAX_LENGTH = 255;

export const SERVICE_NAME = "aloop";
export const SYSTEM_USER_NAME = "aloopサポート（システム）";

export const IMG_VALIDATE = {
    AVATAR_MAX_FILE_SIZE: 8 * 1024 * 1024,
    THUMB_MAX_FILE_SIZE: 8 * 1024 * 1024,
    THUMB_MAX_WIDTH: 1980,
    THUMB_MAX_HEIGHT: 720,
};

export const MOBILE_SCREEN_WIDTH = 767;

export const ITEM_TYPE = {
    NEWS: "news",
    JOB: "job",
}

export const CHAT_USER_ROLE = {
    STAFF: "staff",
    TALENT: "talent"
};

export const NEWS_STATUS_OPTION_TYPE = "news_status";
export const NEWS_STATUS_OPTIONS = {
    PUBLIC: "news_public",
    PRIVATE: "news_private"
}

export const MESSAGE_SEND_FROM = {
    TALENT: "talent",
    CHAT: "chat",
    HOME: "home",
    ACTION: "action",
}

export const SCHEDULE_CHAT_STATUS = {
    ON_GOING: "schedule_chat_on_going",
    PAUSE: "schedule_chat_pause",
    COMPLETE: "schedule_chat_completed"
}

export const TAG_LOGIC_TYPE = "tag_logic_type";

// Extend minute when admin add/update bulk messages
export const BULK_MESSAGE_SESSION_MINUTE_EXTEND = 60;

export const TYPE_MAP = {
    alumni: "a",
    internal_talent: "e",
    external_talent: "o",
};

export const TALENT_TYPE_OPTION_TYPE = "talent_type";
export const TALENT_TYPE = {
    ALUMNI: "alumni",
    INTERNAL: "internal_talent",
    EXTERNAL: "external_talent",
};

export const TALENT_ACTIVITY_TYPE = {
    VIEW_JOB: "view_job",
    CHANGE_JOB: "change_job",
    CHANGE_JOB_SURVEY: "change_job_survey",
    WORK_PARTTIME: "work_parttime",
};

export const STAFF_TYPE = {
    ADMIN: "admin",
    GENERAL: "general"
};

export const PERIODIC_TASK_STATUS = {
    EXPIRED: "EXPIRED",
    SCHEDULED: "SCHEDULED",
};

export const FILTER_TIME_OPTIONS = {
    THIS_MONTH: 1,
    LAST_MONTH: 2,
    LAST_30_DAYS: 3,
    LAST_90_DAYS: 4,
    LAST_YEAR: 5,
    ALL_WEEK: 6,
    ALL_MONTH: 7,    
}

export const MAX_X_CHART_LABELS = 26;

export const TALENT_FILE_TYPE = {
    RESUME: "RESUME",
    CV: "CV",
    OTHER: "OTHER",
}

export const TALENT_REGISTER_CHANNEL_OPTIONS = [
    { id: 1, name: "CSV", value: "csv"},
    { id: 2, name: "WEB", value: "web"}
]